webpackJsonp([19,35],{

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (config) {
	  this.distanceX = 0;
	  this.distanceY = 0;
	  this.startPos = [0, 0];
	  this.currentPos = [0, 0];
	  this.startTime = 0;
	  this.endTime = 0;
	  this.speedX = 0;
	  this.speedY = 0;
	
	  this.state = 'FREE';
	  this.alias = config.alias || '';
	  this.dom = config.dom;
	  this.eventType = config.type || 'swipe';
	  this.callback = config.doing || function () {};
	  this.donecallback = config.done || function () {};
	
	  this.mode = config.mode || 'strict';
	
	  var t = this;
	
	  this.handleTouchStart = function (e) {
	    t.startTime = new Date().getTime();
	    t.state = 'START';
	    var touch = e.targetTouches[0];
	    t.startPos = [touch.pageX, touch.pageY];
	
	    t.callback('touchstart', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.startPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchMove = function (e) {
	    t.state = 'MOVING';
	    var touch = e.targetTouches[0];
	    t.currentPos = [touch.pageX, touch.pageY];
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	    t.callback('touchmove', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.currentPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchEnd = function () {
	    t.state = 'END';
	    t.endTime = new Date().getTime();
	    var time = Math.floor((t.endTime - t.startTime) / 1000);
	
	    if (t.currentPos[0] === 0 || t.currentPos[1] === 0) {
	      t.currentPos = t.startPos;
	    }
	
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	
	    if (time === 0) time = 1;
	    t.speedX = Math.abs(t.distanceX / time);
	    t.speedY = Math.abs(t.distanceY / time);
	
	    if (!t.actions[t.eventType]()) {
	      t.callback('touchend', {
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    } else {
	      if (t.mode === 'unstrict') {
	        t.callback('touchend', {
	          distance: { x: t.distanceX, y: t.distanceY },
	          speed: { x: t.speedX, y: t.speedY },
	          position: t.currentPos,
	          state: t.state,
	          alias: t.alias
	        });
	      }
	
	      t.donecallback({
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    }
	
	    t.state = 'FREE';
	    t.distanceX = 0;
	    t.distanceY = 0;
	    t.startTime = 0;
	    t.endTime = 0;
	    t.speedX = 0;
	    t.speedY = 0;
	    t.startPos = [0, 0];
	    t.currentPos = [0, 0];
	  };
	
	  this.actions = {
	    swipe: function swipe() {
	      return true;
	    },
	    swipeDown: function swipeDown() {
	      if (t.distanceY > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeUp: function swipeUp() {
	      if (t.distanceY < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeLeft: function swipeLeft() {
	      if (t.distanceX < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeRight: function swipeRight() {
	      if (t.distanceX > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeX: function swipeX() {
	      if (Math.abs(t.distanceX) > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeY: function swipeY() {
	      if (Math.abs(t.distanceY) > 60) {
	        return true;
	      }
	      return false;
	    }
	  };
	
	  this.init = function () {
	    this.dom.addEventListener('touchstart', this.handleTouchStart);
	    this.dom.addEventListener('touchmove', this.handleTouchMove);
	    this.dom.addEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.destory = function () {
	    this.dom.removeEventListener('touchstart', this.handleTouchStart);
	    this.dom.removeEventListener('touchmove', this.handleTouchMove);
	    this.dom.removeEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.init();
	};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(112),
	  /* template */
	  __webpack_require__(220),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function Time(str) {
	  this.obj = null;
	  this.time = 0;
	  this.year = 0;
	  this.month = 0;
	  this.date = 0;
	  this.hour = 0;
	  this.minute = 0;
	  this.second = 0;
	
	  this.init(str);
	}
	
	Time.prototype.init = function (str) {
	
	  var d = str.split(' ');
	  var d1 = d[0].split('-');
	
	  if (d1.length === 1) {
	    d1 = d[0].split('/');
	  }
	
	  this.year = parseInt(d1[0]);
	  this.month = parseInt(d1[1]);
	  this.date = parseInt(d1[2]);
	
	  if (d[1]) {
	    var d2 = d[1].split(':');
	    this.hour = parseInt(d2[0]);
	    this.minute = parseInt(d2[1]);
	    this.second = parseInt(d2[2]);
	  }
	
	  this.obj = new Date(this.year, this.month - 1, this.date, this.hour, this.minute, this.second);
	};
	
	Time.prototype.equal = function (aim, min) {
	  var m = min || 'date';
	  var result = false;
	
	  switch (m) {
	    case 'date':
	      {
	        if (this.year === aim.year && this.month === aim.month && this.date === aim.date) {
	          result = true;
	          break;
	        }
	      }
	    default:
	      {
	        result = false;
	      }
	  }
	
	  return result;
	};
	
	Time.prototype.format = function (format) {
	  var result = format.replace('yy', this.year);
	  result = result.replace('mm', this.month);
	  result = result.replace('dd', this.date);
	  result = result.replace('hh', this.hour);
	  result = result.replace('mm', this.minute);
	  result = result.replace('ss', this.second);
	
	  return result;
	};
	
	exports.default = Time;

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _time = __webpack_require__(96);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'calendar',
	  props: {
	    disableDays: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    activeDays: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    unactiveDays: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    maxMonth: {
	      type: Number,
	      default: 12
	    },
	    minMonth: {
	      type: Number,
	      default: 1
	    },
	    mode: {
	      type: String,
	      default: 'todayafter'
	    },
	    showHeader: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    dayClick: function dayClick(data) {
	      if (data.status !== 'disable') {
	        this.$emit('on-click', data);
	      }
	    },
	    next: function next() {
	      if (this.currentMonth === 12) {
	        this.currentMonth = 1;
	        this.currentYear = this.currentYear + 1;
	      } else {
	        this.currentMonth = this.currentMonth + 1;
	      }
	
	      this.$emit('on-month-change', {
	        year: this.currentYear,
	        month: this.currentMonth
	      });
	      this.draw();
	    },
	    pre: function pre() {
	      if (this.currentMonth === 1) {
	        this.currentMonth = 12;
	        this.currentYear = this.currentYear - 1;
	      } else {
	        this.currentMonth = this.currentMonth - 1;
	      }
	
	      this.$emit('on-month-change', {
	        year: this.currentYear,
	        month: this.currentMonth
	      });
	      this.draw();
	    },
	    getDaysOfMonth: function getDaysOfMonth(month) {
	      var d = new Date();
	      var d2 = new Date();
	
	      d.setDate(1);
	      d.setMonth(month - 1);
	
	      d2.setDate(1);
	      d2.setMonth(month);
	
	      var monthStartDate = d.getTime();
	      var monthEndDate = d2.getTime();
	      return (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
	    },
	    getStartDayOfMonth: function getStartDayOfMonth(month) {
	      var d = new Date();
	      d.setDate(1);
	      d.setMonth(month - 1);
	      d.setFullYear(this.currentYear);
	      return d.getDay() === 0 ? 7 : d.getDay();
	    },
	    initByMonth: function initByMonth(month) {
	      this.currentMonth = month;
	      var days = this.getDaysOfMonth(month);
	      var startDay = this.getStartDayOfMonth(month);
	
	      var todayDate = new Date().getDate();
	
	      var daysData = [];
	      for (var i = 0; i < startDay - 1; i++) {
	        daysData.push({
	          id: 0,
	          name: '',
	          state: 'disable'
	        });
	      }
	
	      for (var _i = 0; _i < days; _i++) {
	        var ii = _i + 1;
	        var status = 'normal';
	
	        switch (this.mode) {
	          case 'all':
	            {
	              status = 'normal';
	              break;
	            }
	          case 'todayafter':
	            {
	
	              if (this.currentMonth == new Date().getMonth() + 1 && this.currentYear == this.nowYear) {
	                if (todayDate > ii) {
	                  status = 'disable';
	                }
	              }
	
	              if (this.currentMonth < new Date().getMonth() + 1 && this.currentYear <= this.nowYear) {
	                status = 'disable';
	              }
	
	              if (this.currentYear < this.nowYear) {
	                status = 'disable';
	              }
	
	              break;
	            }
	          case 'after':
	            {
	              if (this.currentMonth == new Date().getMonth() + 1 && this.currentYear == this.nowYear) {
	                if (todayDate >= ii) {
	                  status = 'disable';
	                }
	              }
	              if (this.currentMonth < new Date().getMonth() + 1 && this.currentYear <= this.nowYear) {
	                status = 'disable';
	              }
	
	              if (this.currentYear < this.nowYear) {
	                status = 'disable';
	              }
	            }
	        }
	
	        daysData.push({
	          date: new _time2.default(this.currentYear + '-' + month + '-' + ii),
	          id: _i + 1,
	          name: _i + 1,
	          status: status
	        });
	      }
	
	      this.daysData = daysData;
	    },
	    setStatusOfDay: function setStatusOfDay(day, status) {
	      var index = -1;
	      this.daysData.forEach(function (item, i) {
	        if (item.date && day instanceof _time2.default) {
	          if (item.date.equal(day)) {
	            index = i;
	          }
	        } else if (item.date && typeof day == 'string') {
	          if (item.date.equal(new _time2.default(day))) {
	            index = i;
	          }
	        }
	      });
	
	      if (index >= 0) {
	        var data = this.daysData[index];
	        data.status = status;
	        this.daysData[index] = data;
	      }
	    },
	    translateData: function translateData() {
	      var days = this.getDaysOfMonth(this.currentMonth);
	      var startDay = this.getStartDayOfMonth(this.currentMonth);
	      var lines = Math.ceil((days + startDay - 1) / 7);
	
	      var data = [];
	      for (var i = 0; i < lines; i++) {
	        data[i] = [];
	      }
	
	      this.daysData.forEach(function (item, index) {
	        var lineNumber = Math.floor(index / 7);
	        data[lineNumber].push(item);
	      });
	
	      this.days = data;
	    },
	    draw: function draw() {
	      var _this = this;
	
	      this.initByMonth(this.currentMonth);
	      this.activeDaysSelf.forEach(function (item) {
	        _this.setStatusOfDay(item, 'active');
	      });
	
	      this.unactiveDaysSelf.forEach(function (item) {
	        _this.setStatusOfDay(item, 'unactive');
	      });
	      this.disableDaysSelf.forEach(function (item) {
	        _this.setStatusOfDay(item, 'disable');
	      });
	      this.translateData();
	    }
	  },
	  created: function created() {},
	  beforeDestroy: function beforeDestroy() {},
	  mounted: function mounted() {
	    this.currentMonth = new Date().getMonth() + 1;
	    this.draw();
	  },
	
	  watch: {
	    disableDays: function disableDays(newVal) {
	      this.disableDaysSelf = newVal;
	      this.draw();
	    },
	    activeDays: function activeDays(newVal) {
	      this.activeDaysSelf = newVal;
	      this.draw();
	    },
	    unactiveDays: function unactiveDays(newVal) {
	      this.unactiveDaysSelf = newVal;
	      this.draw();
	    }
	  },
	  data: function data() {
	    return {
	      nowYear: new Date().getFullYear(),
	      currentYear: new Date().getFullYear(),
	      currentMonth: 0,
	      currentDay: 0,
	      currentWeek: 0,
	      disableDaysSelf: this.disableDays,
	      activeDaysSelf: this.activeDays,
	      unactiveDaysSelf: this.unactiveDays,
	      daysData: [],
	      days: [] };
	  }
	};

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(40);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _calendar = __webpack_require__(196);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _touchit = __webpack_require__(3);
	
	var _touchit2 = _interopRequireDefault(_touchit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: '',
	  components: {
	    calendar: _calendar2.default
	  },
	  mounted: function mounted() {
	    this.touch = new _touchit2.default({
	      alias: 'swipeX',
	      dom: this.$refs.touchbox,
	      type: 'swipeX',
	      done: this.done
	    });
	  },
	
	  methods: {
	    done: function done(e) {
	      console.log('done');
	      if (e.distance.x > 0) {
	        this.$refs.calendar.pre();
	      }
	      if (e.distance.x < 0) {
	        this.$refs.calendar.next();
	      }
	    },
	    handle: function handle(data) {
	      this.$toast.open((0, _stringify2.default)(data));
	
	      this.$refs.calendar.setStatusOfDay(data.date, 'active');
	    },
	    monthChange: function monthChange(data) {
	      this.now = data.year + '-' + data.month;
	    }
	  },
	  data: function data() {
	    return {
	      now: '',
	      touch: null
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.touch.destory();
	  }
	};

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(111),
	  /* template */
	  __webpack_require__(275),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card p2222"
	  }, [_c('div', {}, [_vm._v("\n    " + _vm._s(_vm.now) + "\n  ")]), _vm._v(" "), _c('div', {
	    ref: "touchbox"
	  }, [_c('calendar', {
	    ref: "calendar",
	    attrs: {
	      "activeDays": ['2017-4-18', '2017-4-19'],
	      "unactiveDays": ['2017-4-20']
	    },
	    on: {
	      "on-click": _vm.handle,
	      "on-month-change": _vm.monthChange
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendar"
	  }, [_c('table', [_c('thead', [_c('tr', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHeader),
	      expression: "showHeader"
	    }]
	  }, [_c('th', {
	    staticClass: "prev",
	    staticStyle: {
	      "visibility": "visible"
	    },
	    on: {
	      "click": _vm.pre
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-back"
	  })]), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(_vm._s(_vm.currentYear) + "年" + _vm._s(_vm.currentMonth) + "月")]), _vm._v(" "), _c('th', {
	    staticClass: "next",
	    staticStyle: {
	      "visibility": "visible"
	    },
	    on: {
	      "click": _vm.next
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-xiangyou1"
	  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.days), function(item) {
	    return _c('tr', _vm._l((item), function(item2) {
	      return _c('td', {
	        staticClass: "day",
	        on: {
	          "click": function($event) {
	            _vm.dayClick(item2)
	          }
	        }
	      }, [_c('span', {
	        class: [item2.status]
	      }, [_vm._v(_vm._s(item2.name))])])
	    }))
	  }))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', {
	    staticClass: "weekday"
	  }, [_vm._v("一")]), _vm._v(" "), _c('th', {
	    staticClass: "weekday"
	  }, [_vm._v("二")]), _vm._v(" "), _c('th', {
	    staticClass: "weekday"
	  }, [_vm._v("三")]), _vm._v(" "), _c('th', {
	    staticClass: "weekday"
	  }, [_vm._v("四")]), _vm._v(" "), _c('th', {
	    staticClass: "weekday"
	  }, [_vm._v("五")]), _vm._v(" "), _c('th', {
	    staticClass: "weekday"
	  }, [_vm._v("六")]), _vm._v(" "), _c('th', {
	    staticClass: "weekday"
	  }, [_vm._v("日")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.f94675d9bcc6907b973f.js